var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87012 11.5C12.3554 11.5 14.3701 9.48528 14.3701 7C14.3701 4.51472 12.3554 2.5 9.87012 2.5C7.38484 2.5 5.37012 4.51472 5.37012 7C5.37012 9.48528 7.38484 11.5 9.87012 11.5Z",
    stroke: "#0C101B",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8987 3.625C19.6487 2.875 20.7737 2.5 21.8987 2.5C24.3362 2.5 26.3987 4.5625 26.3987 7C26.3987 9.4375 24.3362 11.5 21.8987 11.5C20.7737 11.5 19.6487 11.125 18.8987 10.375",
    stroke: "#0C101B",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8701 32.5291V18.5291L1.87012 18.5291V32.5291",
    stroke: "#0C101B",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8987 32.5291V18.5291H21.8987",
    stroke: "#0C101B",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudience);
export default __webpack_public_path__ + "static/media/Audience.63b2b15f661cf6c5edd5cac08655f88f.svg";
export { ForwardRef as ReactComponent };